export default "__VITE_ASSET__BJx6EzDa__"